import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { border } from './primitive/border';
import {
  primary,
  primaryLightColorScheme,
  surface,
  gray,
  highlight,
  focus,
  formField,
  text,
  anchor,
  overlay,
  list,
  mask,
} from './semantic';
import {
  badge,
  button,
  datatable,
  datepicker,
  multiselect,
  tabs,
  card,
  autocomplete,
  accordion,
  tree,
  treeselect,
  tag,
} from './components';

const tourfoldTheme = definePreset(Aura, {
  primitive: {
    ...border,
  },
  semantic: {
    ...primary,
    colorScheme: {
      light: {
        ...primaryLightColorScheme,
        ...surface,
        ...gray,
        ...highlight,
        ...focus,
        ...formField,
        ...text,
        ...anchor,
        ...overlay,
        ...list,
        ...mask,
      },
    },
  },
  components: {
    ...button,
    ...multiselect,
    ...tabs,
    ...datatable,
    ...datepicker,
    ...badge,
    ...card,
    ...autocomplete,
    ...accordion,
    ...tree,
    ...treeselect,
    ...tag,
  },
});

export default tourfoldTheme;
